import React from 'react'
import "./style.css"



const CustomToastUi = ({text,type}) => {
    
  return (
  <>
    {text ? (
        type == "success" ? (
          <div className="mb-3 success-box">
            <p>{text}</p>
          </div>
        ) : (
          <div className="err-box mb-3">
            <p>{text}</p>
          </div>
        )
      ) : null}
  </>
  )
}

export default CustomToastUi